<template>
  <div id="route">
    <v-dialog v-model="updateRouteDialog" max-width="500px">
        <route-route-form
          :selectedRoute="currentRoute"
          v-on:close-route-dialog="updateRouteDialog = false"
          v-on:error="onUpdateRouteError"
          v-on:success="onUpdateRouteSuccess"
        />
      </v-dialog>
    <confirm-dialog
      :showDialogConfirm="showDialogConfirm"
      :message="message"
      v-on:close-dialog="showDialogConfirm = false"
      v-on:accept="confirmDelete"
    />
    <!-- <ui-loader v-model="loadingProducts" /> -->
    <v-layout row wrap grid-list-xs>
      <v-flex xs12 ma-1>
        <v-card>
          <v-card-title primary-title >
            <v-layout row wrap align-center >
              <v-flex xs12>
                Lote: {{currentBatch.id}}
              </v-flex>
              <v-flex xs12>
                Saco:
                <router-link :to="thisBagRoute">
                {{currentBag.batch_consecutive}} <strong>({{currentBag.type}})</strong>
                </router-link>

              </v-flex>
              <v-flex xs12>
                Ruta: <a  href="#" @click.prevent="showRouteUpdateDialog">{{currentRoute.description}}</a>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs6 class="detail">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <metal-load-detail
                :detail="metalLoad"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <purcharse-order-catalyst-detail
                :items="productsOfThisBag"
                title="Asignados a este saco"
                v-on:deleteItem="deleteItem"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <!-- The tops are stored in the HIGH BAG -->
              <purcharse-order-tops-detail
                header="Tops y Piezas por Kilo"
                :items="productsOfThisBag"
                :showRoute="false"
                :showOperations="true"
                :currentBag="currentBag"
                v-on:deleteItem="deleteItem"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'LOW'" xs12>
              <purcharse-order-dust-detail
                :items="productsOfThisBag"
                title="Asignados a este saco"
                v-on:deleteItem="deleteItem"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'METAL'" xs12>
              <purcharse-order-metal-detail
                :items="productsOfThisBag"
                title="Asignados a este saco"
                v-on:deleteItem="deleteItem"
                :currentBag="currentBag"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs6 >
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs2>
              <v-select
                :items="captureOptionsFilter"
                v-model="currentCapture"
                label="Capturar"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-combobox
                v-model="select"
                :loading="loading"
                :items="searchSuggestions"
                :search-input.sync="search"
                item-text="serial_number"
                item-value="serial_number"
                class="mx-1" hide-no-data hide-details
                label="Número de Serie"
                solo
                v-on:keyup.enter="searchProducts"
                :disabled="currentCapture!=='Piezas'"
                ref="myAutocomplete"
                autofocus>
              </v-combobox>
            </v-flex>
            <v-flex xs4>
              <v-select
                :disabled="currentCapture!=='Piezas'"
                class="ml-1 ml-1" 
                :items="filters2" 
                v-model="selectedFilter2" 
                solo
                item-text="name"
                item-value="id" 
                return-object></v-select>

            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="currentCapture === 'Piezas'">
            <v-flex xs12 v-for="product in productsToShow" :key="product.id">
              <purcharse-order-line-item
                :product="product"
                v-on:add-item="addItem"
                v-on:warning="$emit('error', $event)"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="currentCapture === 'Tortugas'">
            <v-flex xs12>
              <purcharse-order-line-item-turtle
                v-on:add-item="addItem"
                v-on:warning="$emit('error', $event)"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="currentCapture === 'Piedra'">
            <v-flex xs12>
              <purcharse-order-line-item-dust
                v-on:add-item="addItem"
                v-on:warning="$emit('error', $event)"
              />
            </v-flex>
          </v-layout>

            <v-layout row wrap v-if="currentCapture === 'Tops y Piezas Por Kilo'">
            <v-flex xs12>
              <purcharse-order-line-item-top
                v-on:add-item="addItem"
                v-on:warning="$emit('error', $event)"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="currentCapture === 'Metales'">
            <v-flex xs12>
              <purcharse-order-line-item-metal
                v-on:add-item="addItem"
                v-on:warning="$emit('error', $event)"
              />
            </v-flex>
          </v-layout>

        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import _ from 'lodash';

import {
  getRoute,
  getComprobation,
  createComprobation,
  getMetalLoadForRouteInBag,
  } from '../services/route';
import { getBag } from '../services/bag';
import { addLineItem, removeLineItem } from '../services/purcharseOrder';
import { getCurrentBatch } from '../services/batch';
import { PUOND_CONVERT } from '../utils/constants';

function ApplicationException(message) {
   this.message = message;
   this.name = 'ApplicationException';
}

export default {
  data() {
    return {
      // route data
      updateRouteDialog: false,
      currentRoute: {},
      routeComprobation: {},
      currentBag: {},
      currentBatch: {},

      // search by serial number combo data
      itemsSearch: [],
      search: '',
      loading: false,
      currentPage: 1,
      endOfFilter: false,
      scrollLoading: false,
      products: [],
      findingSimilar: false,
      loadingProducts: false,
      suggestions: [],
      select: null,
      selectedFilter: {
        id: 1,
        name: 'Serie',
        field: 'serial_number',
        endpoint: '/catalogs/product/search',
      },
      thumbQueryParam: '',

      // Capture options
      captureOptions: [
        'Piezas',
        'Piedra',
        'Tops y Piezas Por Kilo',
        // 'Tortugas',
        'Metales',
      ],
      currentCapture: 'Piezas',
      errorStatus: '',
      metalLoad: [],
      showDialogConfirm: false,
      message: "",
      bagToDelete: {},
      isAdding: false,
      selectedFilter2: {
        id: 1,
        name: 'Comienza por',
        field: 'begin'
      },
      filters2: [{
          id: 1,
          name: 'Comienza por',
          field: 'begin',
        },
        {
          id: 2,
          name: 'Contiene',
          field: 'contain',
        },
        {
          id: 3,
          name: 'Termina con',
          field: 'end',
        },
        {
          id: 4,
          name: 'Exacto',
          field: 'exact',
        },
      ],
    };
  },

  computed: {
    // methods for search products
    captureOptionsFilter() {
      console.log(this.currentBag);
      // if( this.currentBag != null){
      //   const type = this.currentBag.type
      //   console.log(type);
      //   if(type != null){
      //     switch(type){
      //       case 'HIGH':
      //         this.currentCapture = 'Piezas'
      //         return ['Piezas', 'Tops y Piezas Por Kilo']
      //       case 'LOW':
      //         this.currentCapture = 'Piedra'
      //         return ['Piedra']
      //       case 'METAL':
      //         this.currentCapture = 'Metales'
      //         return ['Metales']
      //     }
      //   }
      // }else{
      //   return this.captureOptions
      // }
      return this.captureOptions
    },
    searchSuggestions() {
      return this.suggestions.map((entry) => {
        const serialNumber = entry.serial_number;
        return Object.assign({}, entry, {
          serialNumber,
        });
      });
    },

    productsToShow() {
      return this.products.filter((p) => {
        return true;
      });
    },

    productsOfThisBag() {
      if (!this.routeComprobation.details) {
        return [];
      }
      const idBag = parseInt(this.$route.params.idBag, 10);
      return this.routeComprobation.details.filter( (p) => {
        if (idBag) {
          return p.id_bag === idBag;
        }
        return false;
      });
    },

    productsOfOtherBag() {
      if (!this.routeComprobation.details) {
        return [];
      }
      const idBag = parseInt(this.$route.params.idBag, 10);
      return this.routeComprobation.details.filter( (p) => {
        if (idBag) {
          return p.id_bag !== idBag;
        }
        return true;
      });
    },
    thisBagRoute() {
      return `/bag/${this.$route.params.idBag}`;
    },
  },

  methods: {
    lineTotals(lineItem) {
      const units = lineItem.whole + lineItem.three_quarter + lineItem.half + lineItem.quarter;
      const pieces = lineItem.whole + (lineItem.three_quarter * 0.75 ) +
        (lineItem.half * 0.5) + (lineItem.quarter * 0.25);
      const realWeigth = pieces * lineItem.weigth;
      return {
        units,
        pieces,
        real_weigth: realWeigth,
        real_weigh_lbl: realWeigth *  PUOND_CONVERT,
      };
    },
    async loadRoute() {
      try {
        const result = await getRoute(this.$route.params.idRoute);
        this.currentRoute  = result.data;
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },
    async loadBag() {
      try {
        const result = await getBag(this.$route.params.idBag);
        this.currentBag  = result.data;
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },
    async loadBatch() {
      if (!this.$route.params.idBatch) {
        const response = await getCurrentBatch();
        this.currentBatch = response.data;
      } else {
        this.axios.get(`/batch/detail/${this.$route.params.idBatch}`)
        .then( (result) => {
            this.currentBatch = Object.assign({}, result.data);
        });
      }
    },
    async loadOrCreateComprobation() {
      if (!this.currentRoute.id) {
        const exception = new ApplicationException('No hay ruta seleccionada para crear la comprobacion');
        throw exception;
      }
      try {
        let resultComprobation = await getComprobation(this.currentRoute.id);
        if (_.isEmpty(resultComprobation.data)) {
          resultComprobation = await createComprobation(this.currentRoute.id);
        }
        this.routeComprobation  = resultComprobation.data;
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },

    resetSearchScreen() {
      this.currentPage = 1;
      this.endOfFilter = false;
      this.scrollLoading = false;
      this.products = [];
      this.findingSimilar = false;
    },

    async searchProducts() {
      try {
        this.resetSearchScreen();
        this.loadingProducts = true;
        if (this.search && this.search !== '') {
          this.reqBody = {
            serial_number: this.search,
            no_zero: true,
            searchExact: this.selectedFilter2.field,
            pagination: {
              current_page: this.currentPage,
              per_page: this.perPage,
            },
          };
          const results =
            await this.axios.post(`${this.selectedFilter.endpoint}?${this.thumbQueryParam}`, this.reqBody);
          this.products = results.data.products;
        }
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.$refs.myAutocomplete.isMenuActive = false;
        this.loadingProducts = false;
      }
    },

    async addItem(event) {
      try {
        if(this.isAdding) {
          return
        }
        this.isAdding = true
        if (this.currentBag) {
          event.id_bag = this.currentBag.id;
        }
        let catalistData = '';
        if (event.type === 'CATALYST') {
          event = Object.assign(event, this.lineTotals(event));
          catalistData = ` (${event.serial_number})`;
        }
        event.id_bag = this.$route.params.idBag;
        let newLineItem =  await addLineItem(this.routeComprobation.id, event);
        const code = newLineItem.data.statusCode
        if(code === 226){
          this.$emit('error', newLineItem.data.friendlyMessage[0]);
        }else{
          newLineItem = newLineItem.data;
          this.routeComprobation.details.push(Object.assign({}, newLineItem));
          this.loadMetalLoadForBag();
          this.$emit('success', `Partida agregada${catalistData}`);
        }
       
      } catch (error) {
        this.$emit('error', error);
      }
      this.isAdding = false
    },
    async confirmDelete() {
      try {
        const result = await removeLineItem(this.backToDelete.id);
        const index = this.routeComprobation.details.indexOf(this.backToDelete);
        this.routeComprobation.details.splice(index, 1);
        this.loadMetalLoadForBag();
        this.$emit('success', 'Partida eliminada');
      } catch (error) {
        this.$emit('error', error);
      }
    },
    async deleteItem(lineItem) {
      this.backToDelete = lineItem
      this.message = `¿Estás seguro de que quieres eliminar la línea seleccionada?`
      this.showDialogConfirm = true
    },

    async loadMetalLoadForBag() {
      try {
        const result = await getMetalLoadForRouteInBag(this.currentRoute, this.currentBag);
        this.metalLoad = result.data;
      } catch (error) {
        this.$emit('error', error);
      }
    },
    onUpdateRouteError(event) {
      this.updateRouteDialog = false;
      this.$emit('error', event);
    },
    onUpdateRouteSuccess(event) {
      this.updateRouteDialog = false;
      this.currentRoute = event;
      this.$emit('success', 'Datos de la ruta actualizados');
    },
    showRouteUpdateDialog() {
      this.updateRouteDialog = true;
    },
  },

  async mounted() {
    await this.loadBatch();
    await this.loadBag();
    await this.loadRoute();
    await this.loadOrCreateComprobation();
    await this.loadMetalLoadForBag();
    if (this.errorStatus) {
      this.$emit('error', this.errorStatus);
      this.errorStatus = '';
    }
  },
};
</script>
<style>
  .detail {
    height: 800px;
    overflow: auto;
  }
  .detail-card {
    height: 100%;
  }
  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
</style>
